function getUniqueByIdArray<T extends { _id: string }>(array: T[]): T[] {
  const map = new Map<string, T>();
  array.forEach((obj) => {
    map.set(obj._id, obj);
  });
  return Array.from(map.values());
}

export default getUniqueByIdArray;
